import React from 'react';

class SessionSelect extends React.Component {

    render() {
        return (
            <option value={this.props.session.SESSION_CODE}>
                {this.props.session.TERM_DESCR30} ({new Date(this.props.session.SESSION_START_DATE).toLocaleDateString('en-US')} - {new Date(this.props.session.SESSION_END_DATE).toLocaleDateString('en-US')})
            </option>
        );
    }
}

export default SessionSelect;
